import { SET_PERMISSIONS, PERMISSION_LOADING } from "./types";

const initialState = {
  permissions: null,   // important: start with null instead of {}
  loading: true,
};

export default function permissionReducer(state = initialState, action) {
  switch (action.type) {

    case PERMISSION_LOADING:
      // Only show loading on first load
      if (state.permissions) {
        return state;
      }

      return { ...state, loading: true };

    case SET_PERMISSIONS:
      return {
        ...state,
        permissions: action.payload,
        loading: false,
      };

    default:
      return state;
  }
}